
<template>
    <div>
        <el-form size="mini">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item :label="$t('reports.raiseOnDate')"
                                  prop="dateFrom">
                        <el-date-picker v-model="form.dateFrom"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('common.customer')"
                                  prop="custNumber">
                        <el-input v-model="form.custNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="$t('serviceTickets.ticketNumber')"
                                  prop="ticketNumber">
                        <el-input v-model="form.ticketNumber"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('serviceTickets.symptoms')"
                                  prop="complaint">
                        <el-input v-model="form.complaint"></el-input>
                    </el-form-item>

                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('reports.toRaisedDate')"
                                  prop="dateTo">
                        <el-date-picker v-model="form.dateTo"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>

                    <el-form-item :label="$t('common.serviceCompany')"
                                  prop="serviceCompany">
                        <el-input v-model="form.serviceCompany"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('reports.state')"
                                  prop="state">
                        <el-input v-model="form.state"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('common.status')"
                                  prop="status">
                        <el-select v-model="form.status"
                                   style="width:100%;">
                            <el-option :label="$t('common.opened')"
                                       value="1"></el-option>
                            <el-option :label="$t('common.closed')"
                                       value="2"></el-option>
                            <el-option :label="$t('common.flagged')"
                                       value="3"></el-option>
                            <el-option :label="$t('common.flaggedClosed')"
                                       value="4"></el-option>
                            <el-option :label="$t('common.escalation')"
                                       value="5"></el-option>
                            <el-option :label="$t('common.escalationClosed')"
                                       value="6"></el-option>
                            <el-option :label="$t('common.postInstallInstall')"
                                       value="7"></el-option>
                        </el-select>
                    </el-form-item>


                </el-col>
            </el-row>

            <el-checkbox-group v-model="form.fields"
                               ref="group"
                               class="fields">
                <el-row>
                    <el-col :span="12">
                        <el-checkbox class="checkbox"
                                     label="1">{{$t('serviceTickets.ticketNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="2">{{$t('serviceTickets.openedBy')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="3">{{$t('common.customer')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="4">{{$t('serviceTickets.raisedOn')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="5">{{$t('reports.serialNumber')}}</el-checkbox>

                    </el-col>
                    <el-col :span="12">

                        <el-checkbox class="checkbox"
                                     label="6">{{$t('serviceTickets.symptoms')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="7">{{$t('common.status')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="8">{{$t('common.serviceCompany')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="9">{{$t('reports.serviceCompanyPhoneNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="10">{{$t('serviceTickets.confirmation')}}</el-checkbox>

                    </el-col>
                </el-row>
            </el-checkbox-group>
            <el-button @click="selectAll">{{$t('common.deSelectAll')}}</el-button>
            <el-button :loading="loading"
                       type="primary"
                       @click="generateReport">{{$t('common.generate')}}</el-button>
            <p class="labelInfo" ref="labelInfo" v-if="this.form.fields.length == 0">{{$t('reports.pleaseSelectatLeastOneColumn')}}</p>
            <p class="labelInfo">{{$t('reports.noDatesChoosenMessage')}}</p>
        </el-form>
    </div>
</template>

<script>
    import api from "../api";

    export default {
        name: "service-tickets-report",
        components: {
        },
        
        data() {
            return {
                form: {
                    fields: []
                },
                loading: false
            };
        },
        
        methods: {
            generateReport() {
                if (this.form.fields.length == 0) {
                    this.$refs["labelInfo"].focus();
                    return;
                }
                this.loading = true;
                api.downloadServiceTicketsReport(this.form).then(response => {
                    this.loading = false;
                    var blob = response.data;
                    var fileName = response.headers["content-disposition"]
                        .split(";")[1]
                        .split("=")[1];
                    fileName = fileName.replace(/"/g, '')
                    if (typeof window.navigator.msSaveBlob !== "undefined") {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var blobURL = window.URL.createObjectURL(blob);
                        var tempLink = document.createElement("a");
                        tempLink.style.display = "none";
                        tempLink.href = blobURL;
                        tempLink.setAttribute("download", fileName);

                        // Safari thinks _blank anchor are pop ups. We only want to set _blank
                        // target if the browser does not support the HTML5 download attribute.
                        // This allows you to download files in desktop safari if pop up blocking
                        // is enabled.
                        if (typeof tempLink.download === "undefined") {
                            tempLink.setAttribute("target", "_blank");
                        }

                        document.body.appendChild(tempLink);
                        tempLink.click();
                        document.body.removeChild(tempLink);
                        window.URL.revokeObjectURL(blobURL);
                    }
                });
            },
            selectAll() {
                if (this.form.fields.length === 10) {
                    this.form.fields = [];
                } else {
                    for (var i = 1; i <= 10; i++) {
                        this.form.fields.push(i + "");
                    }
                }
            }
        }
    };
</script>

<style scoped>
    .checkbox {
        width: 100%;
        margin-left: 0;
    }

    .fields {
        width: 570px;
        margin-bottom: 10px;
    }

    .labelInfo {
        font-size: smaller;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/ServiceTickets.vue